import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a8bc146"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5" }
const _hoisted_2 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5" }
const _hoisted_3 = {
  class: "d-flex justify-content-between",
  style: {"direction":"ltr !important"}
}
const _hoisted_4 = { class: "symbol symbol-25px me-1" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-gray-700 text-start flex-fill px-1 border-bottom" }
const _hoisted_7 = { class: "text-end text-muted" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people ms-1" }, null, -1))
const _hoisted_9 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5 d-flex" }
const _hoisted_10 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light border-hover-info bg-light-success py-2 px-2 rounded w-100" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, " ربات فعال ", -1))
const _hoisted_12 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5 d-flex" }
const _hoisted_13 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light border-hover-info bg-light-success py-2 px-2 rounded w-100" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, " پاسخگوی‌خودکار فعال ", -1))
const _hoisted_15 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5 d-flex" }
const _hoisted_16 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light border-hover-info bg-light-success py-2 px-2 rounded w-100" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "ربات منقضی", -1))
const _hoisted_18 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5 d-flex" }
const _hoisted_19 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light border-hover-info bg-light-success py-2 px-2 rounded w-100" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "خریداران پکیج ", -1))
const _hoisted_21 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5 d-flex" }
const _hoisted_22 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light border-hover-info bg-light-success py-2 px-2 rounded w-100" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "api فعال", -1))
const _hoisted_24 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5 d-flex" }
const _hoisted_25 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light border-hover-info bg-light-success py-2 px-2 rounded w-100" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "دارای تخفیف ", -1))
const _hoisted_28 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5" }
const _hoisted_29 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5" }
const _hoisted_30 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5" }
const _hoisted_31 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5" }
const _hoisted_32 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5" }
const _hoisted_33 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5" }
const _hoisted_34 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5" }
const _hoisted_35 = ["href"]
const _hoisted_36 = { class: "col-sm-6 col-md-3 col-lg-2 mb-5" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-sm btn-white btn-active-light-primary me-2",
  "data-kt-menu-dismiss": "true"
}, " ریست ", -1))
const _hoisted_38 = {
  key: 1,
  class: "badge badge-lg badge-light-primary fw-bold fs-7",
  style: {"max-width":"fit-content"}
}
const _hoisted_39 = { class: "table-responsive" }
const _hoisted_40 = { class: "fw-bolder text-muted text-center bg-light" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap min-w-90px mw-90px min-w-90px" }, null, -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" کاربر ")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "نقش کاربری", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap min-w-90px" }, "بازدید", -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" پرداختی ")
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap min-w-90px bg-hover-light-info" }, " کیف پول ", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap min-w-90px" }, "دستگاه", -1))
const _hoisted_48 = { class: "text-end" }
const _hoisted_49 = { class: "d-flex flex-nowrap" }
const _hoisted_50 = { class: "el-dropdown-link" }
const _hoisted_51 = { class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1" }
const _hoisted_52 = { class: "svg-icon svg-icon-3" }
const _hoisted_53 = ["disabled", "onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["href"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm btn-outline-default" }, " تغییر سطح دسترسی کاربر ", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["href"]
const _hoisted_60 = { class: "svg-icon svg-icon-3" }
const _hoisted_61 = { class: "d-flex align-items-center" }
const _hoisted_62 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_63 = { class: "mb-1 fs-7 d-flex" }
const _hoisted_64 = {
  key: 0,
  class: "symbol symbol-20px me-1"
}
const _hoisted_65 = ["src"]
const _hoisted_66 = {
  class: "text-muted fw-bold d-block fs-7 d-flex text-end",
  dir: "ltr"
}
const _hoisted_67 = { class: "badge badge-light-success" }
const _hoisted_68 = { class: "text-muted text-nowrap fw-bold d-block fs-7" }
const _hoisted_69 = {
  key: 0,
  class: "text-success fw-bolder text-hover-primary d-block mb-1 fs-6"
}
const _hoisted_70 = { class: "fs-10" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { class: "fs-10" }
const _hoisted_73 = {
  key: 0,
  class: "p-5"
}
const _hoisted_74 = {
  key: 0,
  class: "d-flex align-items-start justify-content-center"
}
const _hoisted_75 = {
  class: "d-flex justify-content-center flex-stack flex-wrap",
  dir: "ltr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_Date = _resolveComponent("Date")!
  const _component_Currency = _resolveComponent("Currency")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_CreateNewFinancialLog = _resolveComponent("CreateNewFinancialLog")!
  const _component_CrudUserModal = _resolveComponent("CrudUserModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(`${_ctx.widgetClasses} ${_ctx.route.name === 'adminsList' ? 'card' : ''}`)
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`${
        _ctx.route.name === 'adminsList' ? 'card-body' : 'card-body py-0 scroll-y'
      }`),
        "element-loading-text": "درحال بارگزاری..."
      }, [
        (_ctx.route.name === 'adminsList')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["row shadow-sm rounded", `${_ctx.route.name === 'adminsList' ? 'pt-5 mb-5' : ''}`])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_input, {
                    size: "small",
                    class: "form-control form-control-solid border-0 p-0",
                    placeholder: "جستجو کاربر",
                    modelValue: _ctx.filterData.q,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterData.q) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_select, {
                  size: "small",
                  placeholder: _ctx.translate('Select country'),
                  modelValue: _ctx.filterData.country_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterData.country_id) = $event)),
                  name: "country_name",
                  dir: "ltr",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesList, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (item.users_count > 0)
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 0,
                              label: item.name,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  _createElementVNode("span", _hoisted_4, [
                                    _createElementVNode("img", {
                                      class: "rounded-1",
                                      src: `https://flagcdn.com/w40/${item?.alpha2_code.toLowerCase()}.webp`,
                                      alt: "Inboxino"
                                    }, null, 8, _hoisted_5)
                                  ]),
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.name.substring(0, 25)), 1),
                                  _createElementVNode("div", _hoisted_7, [
                                    _hoisted_8,
                                    _createTextVNode(" " + _toDisplayString(item?.users_count), 1)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    value: "user",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterData.has_active_bot) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.filterData.has_active_bot]
                  ]),
                  _hoisted_11
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    value: "1",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterData.has_enable_secretary) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.filterData.has_enable_secretary]
                  ]),
                  _hoisted_14
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    value: "1",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterData.has_expired_bot) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.filterData.has_expired_bot]
                  ]),
                  _hoisted_17
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    value: "1",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterData.buy_package) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.filterData.buy_package]
                  ]),
                  _hoisted_20
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    value: "1",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterData.has_enable_api) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.filterData.has_enable_api]
                  ]),
                  _hoisted_23
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: !_ctx.filterData.buy_package,
                    type: "checkbox",
                    class: "form-check-input",
                    value: "1",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterData.use_discount) = $event))
                  }, null, 8, _hoisted_26), [
                    [_vModelCheckbox, _ctx.filterData.use_discount]
                  ]),
                  _hoisted_27
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_input, {
                    size: "small",
                    type: "number",
                    class: "form-control form-control-solid border-0 p-0",
                    placeholder: "تعداد خرید",
                    modelValue: _ctx.filterData.buy_packages_count,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterData.buy_packages_count) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_input, {
                    size: "small",
                    type: "text",
                    class: "form-control text-center form-control-solid border-0 p-0",
                    placeholder: "کد تخفیف",
                    modelValue: _ctx.filterData.use_discount_id,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filterData.use_discount_id) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.filterData.registered_from,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filterData.registered_from) = $event)),
                  clearable: "",
                  format: "YYYY-MM-DD",
                  "display-format": "jMMMM jD",
                  placeholder: "شروع ثبت نام"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.filterData.registered_to,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filterData.registered_to) = $event)),
                  clearable: "",
                  format: "YYYY-MM-DD",
                  "display-format": "jMMMM jD",
                  placeholder: "پایان ثبت نام"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.filterData.buy_from_date,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filterData.buy_from_date) = $event)),
                  clearable: "",
                  format: "YYYY-MM-DD",
                  "display-format": "jMMMM jD",
                  placeholder: "خرید از"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.filterData.buy_to_date,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filterData.buy_to_date) = $event)),
                  clearable: "",
                  format: "YYYY-MM-DD",
                  "display-format": "jMMMM jD",
                  placeholder: "خرید تا"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("a", {
                  download: "",
                  href: _ctx.excelLink,
                  type: "button",
                  class: "btn btn-sm btn-outline-success w-100 border-dashed",
                  "data-kt-menu-dismiss": "true"
                }, " اکسل ", 8, _hoisted_35)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-sm btn-primary",
                  "data-kt-menu-dismiss": "true",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.getItems && _ctx.getItems(...args)))
                }, " اعمال ")
              ])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.pagination)
          ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(Number(_ctx.pagination.total).toLocaleString()) + " کاربر ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("table", {
            class: _normalizeClass(["table table-row-dashed table-bordered table-row-bordered table-sm table-striped align-middle gs-0 gy-2", `${_ctx.route.name === 'table-bordered' ? '' : ''}`])
          }, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("th", {
                  class: "text-nowrap min-w-90px mw-225px rounded-start bg-hover-light-info",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sortBy('user')))
                }, [
                  _hoisted_42,
                  _createElementVNode("i", {
                    class: _normalizeClass(["bi bi-caret-down-fill", _ctx.filterData.sort === 'user' ? 'text-primary' : ''])
                  }, null, 2)
                ]),
                _hoisted_43,
                _hoisted_44,
                _createElementVNode("th", {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sortBy('payment'))),
                  class: "min-w-90px bg-hover-light-info"
                }, [
                  _hoisted_45,
                  _createElementVNode("i", {
                    class: _normalizeClass(["bi bi-caret-down-fill", _ctx.filterData.sort === 'payment' ? 'text-primary' : ''])
                  }, null, 2)
                ]),
                _hoisted_46,
                _hoisted_47
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (user, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_el_dropdown, null, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    disabled: !_ctx.permission?.includes('user_edit'),
                                    class: "btn btn-sm btn-outline-default",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#kt_modal_crate_users_list_modal",
                                    onClick: ($event: any) => (_ctx.editUser = user)
                                  }, " ویرایش ", 8, _hoisted_53)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_dropdown_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#new_financial_log_modal",
                                    class: "btn btn-sm btn-outline-default",
                                    onClick: ($event: any) => (_ctx.selectedUser = user)
                                  }, " کیف پول ", 8, _hoisted_54)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_dropdown_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    href: `/management/users/${user.id}/history?type=per`
                                  }, _hoisted_57, 8, _hoisted_55)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_50, [
                            _createElementVNode("button", _hoisted_51, [
                              _createElementVNode("span", _hoisted_52, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen052.svg" })
                              ])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_tooltip, {
                        content: "جزئیات",
                        placement: "top",
                        effect: "dark"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            disabled: !_ctx.permission?.includes('user_detail'),
                            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                          }, [
                            _createElementVNode("a", {
                              href: `/management/users/${user.id}/history`,
                              target: "_blank"
                            }, [
                              _createElementVNode("span", _hoisted_60, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/technology/teh002.svg" })
                              ])
                            ], 8, _hoisted_59)
                          ], 8, _hoisted_58)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_61, [
                      _createVNode(_component_UserAvatar, {
                        avatar: user.picture,
                        size: "40px",
                        id: user.id
                      }, null, 8, ["avatar", "id"]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("span", _hoisted_63, [
                          (user.country)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                                _createVNode(_component_el_tooltip, {
                                  content: `${user.country.name}`,
                                  placement: "top",
                                  effect: "dark"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      class: "rounded-1",
                                      src: `https://flagcdn.com/w40/${user.country.alpha2_code.toLowerCase()}.webp`,
                                      alt: "Inboxino"
                                    }, null, 8, _hoisted_65)
                                  ]),
                                  _: 2
                                }, 1032, ["content"])
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(_toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 1)
                        ]),
                        _createElementVNode("span", _hoisted_66, _toDisplayString(user.mobile), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getType(user.type)), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_67, _toDisplayString(user.last_seen?.diff_for_humans), 1),
                    _createElementVNode("span", _hoisted_68, [
                      _createVNode(_component_Date, {
                        date: user.formatted_created_at
                      }, null, 8, ["date"])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    (user.total_paid > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                          _createTextVNode(_toDisplayString(user.total_paid.toLocaleString()) + " ", 1),
                          _createElementVNode("span", _hoisted_70, [
                            _createVNode(_component_Currency)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    (user.credit > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                          _createTextVNode(_toDisplayString(Number(user.credit).toLocaleString()) + " ", 1),
                          _createElementVNode("span", _hoisted_72, [
                            _createVNode(_component_Currency)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    (user && user.user_agent)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(user.user_agent.device_type), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ], 2)
        ])
      ], 2)), [
        [_directive_loading, _ctx.loading]
      ]),
      (_ctx.route.name === 'adminsList')
        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              (_ctx.pagination && _ctx.pagination.total_pages > 1)
                ? (_openBlock(), _createBlock(_component_el_pagination, {
                    key: 0,
                    pagerCount: 4,
                    background: "",
                    layout: "prev, pager, next",
                    class: "mt-4 mb-4",
                    total: _ctx.pagination.total,
                    currentPage: _ctx.pagination.current_page,
                    "page-size": _ctx.pagination.per_page,
                    onCurrentChange: _ctx.handleCurrentChange
                  }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_CreateNewFinancialLog, { user: _ctx.selectedUser }, null, 8, ["user"]),
    _createVNode(_component_CrudUserModal, {
      onRefreshUsersList: _ctx.getItems,
      user: _ctx.editUser
    }, null, 8, ["onRefreshUsersList", "user"])
  ], 64))
}